module.exports = __webpack_public_path__ + "img/homeBannerRight.71ee0a7d.png";